module.exports = __webpack_public_path__ + "static/media/printing-services-img13.8c18ce53.jpg";